import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { Typography, Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
const StyledTooltip = withStyles({
  tooltip: {
    color: 'white',
    backgroundColor: 'gray',
    fontSize: '1em'
  }
})(Tooltip);
export const Placeholder = props => {
  const {
    selectProps,
    innerProps = {},
    children
  } = props;
  const {
    placeholder,
    tooltipTitle,
    editablePlaceholder
  } = children;
  return tooltipTitle ? /*#__PURE__*/React.createElement(StyledTooltip, {
    title: tooltipTitle,
    "aria-label": "min-standards-met"
  }, /*#__PURE__*/React.createElement(Typography, _extends({
    color: "textSecondary",
    className: selectProps.classes.placeholder
  }, innerProps), placeholder)) : /*#__PURE__*/React.createElement(Typography, _extends({
    color: editablePlaceholder ? 'textPrimary' : 'textSecondary',
    className: selectProps.classes.placeholder
  }, innerProps), placeholder);
};